import React, { useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useTranslationHook from "../hooks/useTranslationHook";
import useDidMountEffect from "../hooks/useDidMountEffect";
import { useSelector } from "react-redux";
import KycSuccessPrivateAuction from "./KycSuccessPrivateAuction";

const Success = (payload = {}) => {
    const location = useLocation();
    const navigate = useNavigate()
    const { state } = location;
    const { module, onClose, type } = payload
    const { t } = useTranslationHook();
    const isBidderRegistrationModule = module === "bidder_registration";
    const privateAuctionDetails = useSelector((state) => state.buyer.privateAuctionDetails);


    const { propertyId, currentPathName, selectedSessionID, lotID, reg_type } = state || {};

    useDidMountEffect(() => {
        return () => {
            onClose?.();
        };
    }, [onClose]);

    const isBidderError = type === "error";
    const isBidderSuccess = type === "success";

    const handleFailureRedirect = () => {
        // if (propertyId && selectedSessionID && lotID && isBidderError) {
        //     navigate("/live-auction-details", {
        //         replace: true,
        //         state: { selectedSessionID, lotID, propertyId }
        //     });
        //     return;
        // }
        let targetPath = "/";
        if (typeof currentPathName === "string" && currentPathName.trim() !== "") {
            try {
                const url = new URL(currentPathName, window.location.origin);
                targetPath = url.pathname + url.search + url.hash;
            } catch (err) {
                console.warn("Invalid URL, falling back:", currentPathName);
            }
        }
        navigate(targetPath, {
            replace: true,
            state: { selectedSessionID, lotID, propertyId }
        });
    };

    if(privateAuctionDetails?.property_id){
        return <KycSuccessPrivateAuction/>
    }

    if (selectedSessionID && lotID && reg_type === "1" && isBidderSuccess) {
        return <div className="lot-success">
            <p className='mb0'>
                <img src="/img/check-L.svg" alt="Check icon" />
            </p>
            <h3>
                {t("Registration confirmed!")}
            </h3>
            <h6>
                {t("Be ready to place your bids the moment the live auction begins")}
            </h6>
            <div className="mt-3" onClick={handleFailureRedirect}>
                <button className='btn btn-primary'>{t("Return to lot details")}</button>
            </div>
        </div>
    }

    if (selectedSessionID && lotID && reg_type === "2" && isBidderSuccess) {
        return <div className="lot-success">
            <p className='mb0'>
                <img src="/img/check-P.svg" alt="Check icon" />
            </p>
            <h3>
                {t("Registration Pending")}
            </h3>
            <h6>
                {t("Your principal registration is being reviewed by our admin team.")}
            </h6>

            <div className="pending-notify">
                {t("We will notify you via email once your registration has been approved. This typically takes 1-2 business hours.")}
            </div>

            <div className="mt-3" onClick={handleFailureRedirect}>
                <button className='btn btn-primary'>{t("Return to lot details")}</button>
            </div>
        </div>
    }

    return (

        <section className="verify-process-wrap">
            <div className="container py-5">
                <div className="row justify-content-md-center">
                    <div
                        className="col-lg-6 wow fadeInUp"
                        data-wow-delay="0.5s"
                    >
                        <div className="verify-box center">
                            <div className="payment-check mb-3">
                                <img
                                    src={`/img/payment-${isBidderRegistrationModule && isBidderError ? "uncheck" : "check"}.svg`}
                                    alt="Payment Check"
                                />
                            </div>
                            <h4 className="display-4 mb-4">
                                {t(
                                    isBidderRegistrationModule
                                        ? isBidderSuccess
                                            ? "Your request has been submitted successfully!"
                                            : isBidderError
                                                ? "Your request could not be processed."
                                                : ""
                                        : "Verification Successful!"
                                )}
                            </h4>
                            <p className="text mb-5">
                                {t(
                                    isBidderRegistrationModule
                                        ? isBidderSuccess
                                            ? "You can now access the auction platform and participate in bidding."
                                            : isBidderError
                                                ? "Please try again or contact support if the issue persists."
                                                : ""
                                        : "Document Success Review"
                                )}
                            </p>
                            <div>
                                <button
                                    onClick={
                                        isBidderRegistrationModule
                                            ? handleFailureRedirect
                                            : () => navigate("/")
                                    }
                                    className="btn btn-primary btn-lg btn-full"
                                >
                                    {t(isBidderRegistrationModule ? "Return to lot details" : "Start Browsing")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default Success;
